import { render, staticRenderFns } from "./UserVerify.vue?vue&type=template&id=4c9c0742&scoped=true"
import script from "./UserVerify.vue?vue&type=script&lang=js"
export * from "./UserVerify.vue?vue&type=script&lang=js"
import style0 from "./UserVerify.vue?vue&type=style&index=0&id=4c9c0742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9c0742",
  null
  
)

export default component.exports